<template>
    <app-layout title="0-facturen">
        <template #header>
            <page-title title="0-facturen" />
        </template>

        <template #pageContent>
            <div class="">
                <TableSearch tableId="overview-zero-invoices" :values="ZeroInvoiceRequests" class="w-1/4" placeholder="Zoeken"/>
            </div>

            <Table id="overview-zero-invoices" :values="ZeroInvoiceRequests" class="mt-4 w-1/3">
                <thead>
                <tr>
                    <Th id="request.reference">Referentie aanvraag</Th>
                    <Th :sort="false">Goedkeuren</Th>
                    <Th :sort="false"></Th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="zeroInvoiceRequest in state.sortedValues['overview-zero-invoices']" :key="zeroInvoiceRequest.id">
                    <Td>{{ zeroInvoiceRequest.request.reference }}</Td>
                    <Td class="text-center">
                        <Button
                            htmlType="a"
                            buttonClass="approve"
                            size="small"
                            title="Goedkeuren"
                            @click="approve(zeroInvoiceRequest)"
                        />
                    </Td>
                    <Td class="w-[40px]">
                        <Button
                            htmlType="a"
                            buttonClass="show"
                            size="small"
                            title="Details"
                            :href="route('requests.detail',  {'id': zeroInvoiceRequest.request.id})"
                        />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'

import store from '@/store'
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
    },
    props: [
        'ZeroInvoiceRequests',
    ],
    setup (props){

        function approve(zeroInvoiceRequest)
        {
            if (!confirm('Bent u zeker dat u de 0-factuur voor deze aanvraag (' + zeroInvoiceRequest.request.reference + ') wil goedkeuren?'))
                return

            Inertia.post(route('accountancy.approve-zero-invoice', { 'zeroInvoice': zeroInvoiceRequest.id }))
        }

        return {
            state: store.state,
            ...store,
            approve,
        }
    },
}

</script>
